











import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';
import { RouterHelper } from '../router';

@Component({
  components: {
  },
})

export default class SidebarLink extends Vue {
  @Prop() private targetRoute!: string;
  @Prop() private routeName!: string;
  @Prop() private icon!: string;
  @Prop() private disabled!: boolean;

  private get getIcon() {
    return `mdi-${this.icon}`;
  }

  private handleAction(e: any) {
    if (!this.disabled) {
      this.$emit('linkClick', e);
    }
  }

  private get toRoute() {
    if (!this.disabled) {
      return this.targetRoute;
    }
    return '';
  }

  private get isRouteActive() {
    if (this.routeName === 'compose' && RouterHelper.isCompose()) {
      return true;
    } else if (this.routeName === 'consume' && RouterHelper.isConsume()) {
      return true;
    } else if (this.routeName === 'publish' && RouterHelper.isPublish()) {
      return true;
    } else if (this.routeName === 'admin' && RouterHelper.isAdmin()) {
      return true;
    } else if (this.routeName === 'home' && RouterHelper.isHome()) {
      return true;
    }  else if (this.routeName === 'network-map' && RouterHelper.isMap()) {
      return true;
    } else if (this.routeName === 'inventory' && RouterHelper.isInventory()) {
      return true;
    } else if (this.routeName === 'account' && RouterHelper.isAccounts()) {
      return true;
    }
    if (this.targetRoute && this.$route.path.startsWith(this.targetRoute)) {
      return true;
    }
    return this.$route.name === this.routeName;
  }
}
